import numeral from 'numeral'

// Makes sure only thing changed in filter is the city
export function getTextWidth(txt, font) {
  let element = document.createElement('canvas')
  let context = element.getContext('2d')
  context.font = font
  return context.measureText(txt).width + 16
}

export function increaseBrightness(hex, percent) {
  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, '')

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length == 3) {
    hex = hex.replace(/(.)/g, '$1$1')
  }

  var r = parseInt(hex.substr(0, 2), 16),
    g = parseInt(hex.substr(2, 2), 16),
    b = parseInt(hex.substr(4, 2), 16)

  return (
    '#' +
    (0 | ((1 << 8) + r + ((256 - r) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + g + ((256 - g) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substr(1)
  )
}

export function isOverflowActive(event) {
  return event
    ? event.offsetHeight < event.scrollHeight ||
        event.offsetWidth < event.scrollWidth
    : false
}

export function strToRGB(str) {
  if (!str) return '000000'
  var hash = 0
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  var color = (hash & 0x00ffffff).toString(16).toUpperCase()
  return '000000'.substring(0, 6 - color.length) + color
}

export function formatNumber(number) {
  return numeral(number)
    .format('0.0a')
    .replace(/\.0(?=[kmbt]?$)/, '')
    .replace('m', 'M')
    .replace('b', 'B')
}

export function formatMinutesToHours(minutes) {
  if (minutes == null) {
    return `0m`
  }

  minutes = Math.ceil(minutes)

  if (minutes < 60) {
    return `${minutes}m`
  }

  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`
}
export function getEnergyUnit(maxValue) {
  if (maxValue >= 1_000_000) return { divisor: 1_000_000, unit: 'GWh' }
  if (maxValue >= 1_000) return { divisor: 1_000, unit: 'MWh' }
  return { divisor: 1, unit: 'kWh' }
}
export function getMoneyUnit(maxValue) {
  if (maxValue >= 1_000_000_000) return { divisor: 1_000_000_000, unit: 'B' }
  if (maxValue >= 1_000_000) return { divisor: 1_000_000, unit: 'M' }
  if (maxValue >= 1_000) return { divisor: 1_000, unit: 'K' }

  return { divisor: 1, unit: '' }
}
export function formatXAxisDate(date, period) {
  return new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  })
}
export function formatMonthWithOptionalYear(date, showYear) {
  const formatMonth = (date) =>
    date.toLocaleString('default', { month: 'long' })

  return showYear
    ? `${formatMonth(date)} ${date.getFullYear()}`
    : `${formatMonth(date)}`
}
export function getSeriesLabelsByPeriod(period) {
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth()
  const formatMonth = (date) =>
    date.toLocaleString('default', { month: 'long' })

  switch (period) {
    case 'thisMonth': {
      const curr = new Date(currentYear, currentMonth)
      const prev = new Date(currentYear, currentMonth - 1)

      const showYear = curr.getFullYear() !== prev.getFullYear()

      return {
        current: formatMonthWithOptionalYear(curr, showYear),
        previous: formatMonthWithOptionalYear(prev, showYear),
      }
    }

    case 'lastMonth': {
      const curr = new Date(currentYear, currentMonth - 1)
      const prev = new Date(currentYear, currentMonth - 2)

      const showYear = curr.getFullYear() !== prev.getFullYear()

      return {
        current: formatMonthWithOptionalYear(curr, showYear),
        previous: formatMonthWithOptionalYear(prev, showYear),
      }
    }

    case 'last3Months': {
      const endCurr = new Date(currentYear, currentMonth - 1)
      const startCurr = new Date(currentYear, currentMonth - 3)

      const endPrev = new Date(currentYear, currentMonth - 4)
      const startPrev = new Date(currentYear, currentMonth - 6)

      const showYear =
        startCurr.getFullYear() !== endCurr.getFullYear() ||
        startPrev.getFullYear() !== endPrev.getFullYear()

      return {
        current: showYear
          ? `${formatMonth(
              startCurr,
            )} ${startCurr.getFullYear()} – ${formatMonth(
              endCurr,
            )} ${endCurr.getFullYear()}`
          : `${formatMonth(startCurr)} – ${formatMonth(endCurr)}`,

        previous: showYear
          ? `${formatMonth(
              startPrev,
            )} ${startPrev.getFullYear()} – ${formatMonth(
              endPrev,
            )} ${endPrev.getFullYear()}`
          : `${formatMonth(startPrev)} – ${formatMonth(endPrev)}`,
      }
    }

    case 'last6Months': {
      const endCurr = new Date(currentYear, currentMonth - 1)
      const startCurr = new Date(currentYear, currentMonth - 6)

      const endPrev = new Date(currentYear, currentMonth - 7)
      const startPrev = new Date(currentYear, currentMonth - 12)

      const showYear =
        startCurr.getFullYear() !== endCurr.getFullYear() ||
        startPrev.getFullYear() !== endPrev.getFullYear()

      return {
        current: showYear
          ? `${formatMonth(
              startCurr,
            )} ${startCurr.getFullYear()} – ${formatMonth(
              endCurr,
            )} ${endCurr.getFullYear()}`
          : `${formatMonth(startCurr)} – ${formatMonth(endCurr)}`,

        previous: showYear
          ? `${formatMonth(
              startPrev,
            )} ${startPrev.getFullYear()} – ${formatMonth(
              endPrev,
            )} ${endPrev.getFullYear()}`
          : `${formatMonth(startPrev)} – ${formatMonth(endPrev)}`,
      }
    }
    case 'thisYear':
      return {
        current: `${currentYear}`,
        previous: `${currentYear - 1}`,
      }

    case 'lastYear':
      return {
        current: `${currentYear - 1}`,
        previous: `${currentYear - 2}`,
      }

    default: {
      const year = Number(period)
      if (!isNaN(year)) {
        return {
          current: `${year}`,
          previous: `${year - 1}`,
        }
      }

      return {
        current: 'Current',
        previous: 'Previous',
      }
    }
  }
}
